import { SizeField } from '../fields/size';
import { StopPriceField } from '../fields/stop_price';
import { PriceField } from '../fields/price';
import { OrderSliderField } from '../fields/order_slider';

export function StopLimitForm() {
  return (
    <>
      <StopPriceField fieldName="stopPrice" />
      <PriceField fieldName="price" showMidButton={true} />
      <SizeField priceFieldName="price" />
      <OrderSliderField />
    </>
  );
}
